import * as ENV          from '../../util/env';
import { useContext }    from 'react';
import { useEffect }     from 'react';
import connectProgress   from './connect_progress';
import GoogleAuthCordova from './google_auth_cordova';
import GoogleAuthWeb     from './google_auth_web';
import NotFoundPage      from '../../components/not_found_page';
import React             from 'react';
import Rollbar           from '../../rollbar';
import useObjectState    from '../../hooks/use_object_state';


const initialState = {
  client:      null,
  error:       null,
  isSignedIn:  null,
  accessToken: null
};

export default function GoogleAuth({ requireReauthorization, children }) {
  const [ state, updateState ] = useObjectState(initialState);

  const AuthComponent = (
    ENV.isCordova() ?
      GoogleAuthCordova :
      GoogleAuthWeb
  );

  return (
    <GoogleAuth.Context.Provider value={state}>
      <AuthComponent {...{ state, updateState, requireReauthorization }}/>
      {children}
    </GoogleAuth.Context.Provider>
  );
}

GoogleAuth.Context             = React.createContext();
GoogleAuth.Context.displayName = 'GoogleAuthContext';

export function useClient() {
  const { client } = useContext(GoogleAuth.Context);
  return client;
}

export function useAccessToken() {
  const { accessToken } = useContext(GoogleAuth.Context);
  return accessToken;
}

function Failed({ children }) {
  const { error } = useContext(GoogleAuth.Context);

  if (!error)
    return null;

  return children;
}

function Loading({ children }) {
  const { client, error } = useContext(GoogleAuth.Context);

  if (client || error)
    return null;

  return children;
}

function Loaded({ children }) {
  const { client, error } = useContext(GoogleAuth.Context);

  if (error)
    return null;

  if (!client)
    return null;

  return children;
}

function SignedIn({ children }) {
  const { isSignedIn } = useContext(GoogleAuth.Context);

  if (isSignedIn !== true)
    return null;

  return children;
}

function SignedOut({ children }) {
  const { isSignedIn } = useContext(GoogleAuth.Context);

  if (isSignedIn !== false)
    return null;

  return children;
}

function LoadingSpinner({ progressStart, progressEnd }) {
  useEffect(() => {
    progressStart();
    return progressEnd;
  }, [ progressStart, progressEnd ]);
  return null;
}


function FailedView() {
  Rollbar.error('Failed to load Google authentication client.');
  return (<NotFoundPage title="Oops! We’re having trouble connecting to Google."/>);
}

GoogleAuth.Loaded      = Loaded;
GoogleAuth.SignedIn    = SignedIn;
GoogleAuth.SignedOut   = SignedOut;
GoogleAuth.Failed      = Failed;
GoogleAuth.FailedView  = FailedView;
GoogleAuth.Loading     = Loading;
GoogleAuth.LoadingView = connectProgress(LoadingSpinner);
